import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { publishDinoForbidden } from '@mercedes-benz/tdms-next-ui-components';

import { TDMSApi, tdmsApiRef } from './api/tdms.api';
import { rootRouteRef } from './route';

export const tdmsNextPlugin = createPlugin({
  apis: [
    createApiFactory({
      api: tdmsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) => {
        const api = new TDMSApi({
          discoveryApi,
          identityApi,
          onForbidden: publishDinoForbidden,
        });

        // Eagerly warm up the SDK during plugin startup so the first caller
        // does not block on discovery + SDK setup.
        void api.initialize();

        return api;
      },
    }),
  ],
  id: 'tdms-next',
  routes: {
    root: rootRouteRef,
  },
});

export const TdmsNextPage = tdmsNextPlugin.provide(
  createRoutableExtension({
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
    name: 'TdmsNextPage',
  }),
);
